import { useState, useEffect } from 'react';
import { Button, Form } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { VscLoading } from 'react-icons/vsc';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { FormGroup } from '../../../Components/FormGroup/FormGroup';
import OTPInput from '../../../Components/OTPInput';
import { loginWithOtp } from '../../../Redux/slices/user';
import { fetchWrapper } from '../../../_helpers/fetchWrapper';
import { ErrorMessageHandler } from '../../../_helpers/_methods';
import ResendOTP from './ResendOTP';

function SigninWithOTP({ from, usernameValue }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({
    mode: 'onBlur',
    defaultValues: {
      username: usernameValue
    }
  });
  const appliedEvent = useSelector((state) => state.event.appliedEvent);

  /* step 1: Ask for username/email. button "Send OTP"
        step 2: Ask for OTP. button "Sign in"
        */
  const [step, setStep] = useState(1);
  const [username, setUsername] = useState(1);
  const [loading, setLoading] = useState(false);
  const [OTP, setOTP] = useState([]);
  const [count, setCount] = useState(0);
  const handleOTPChange = (otp) => {
    setOTP(otp);
  };
  const [counter, setCounter] = useState(59);
  useEffect(() => {
    const timer = counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
    return () => clearInterval(timer);
  }, [counter]);

  const onSubmit = async (data) => {
    try {
      if (step === 1) {
        //handle get otp
        setLoading(true);
        setUsername(data.username);
        const body = {
          username: data.username
        };
        await fetchWrapper.post('/resend-otp/', body);
        setStep(2);
        setLoading(false);
      } else {
        setLoading(true);
        const body = {
          username: data.username,
          otp: OTP.join('')
        };
        let redirectTo = false;
        if (appliedEvent) {
          redirectTo = '/events/' + appliedEvent;
        }
        await dispatch(loginWithOtp(body, navigate, redirectTo));
        setLoading(false);
        // handle otp login
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
      ErrorMessageHandler(error);
    }
  };

  const handleOTPReset = () => {
    setCounter(59);
    setOTP([]);
    setCount(count + 1);
  };

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <div className="mb-4">
        <Form.Group>
          {step === 1 ? (
            <FormattedMessage id="phone_or_email">
              {(placeholder) => (
                <FormGroup
                  label={placeholder[0]}
                  type="text"
                  placeholder={placeholder[0]}
                  errorId="Phone_no_email"
                  id="username"
                  register={register}
                  error={errors}
                  disabled={loading}
                  required={true}
                />
              )}
            </FormattedMessage>
          ) : (
            <>
              <p className="alert alert-success text-center">
                <FormattedMessage id="login.otpmessage" />
              </p>
              <label>
                <FormattedMessage id="otp_verification" />{' '}
              </label>
              <div className="d-flex justify-content-center">
                <OTPInput key={count} OTP={OTP} setOTP={handleOTPChange} />
              </div>
            </>
          )}
        </Form.Group>
        {/* {from !== 'forgot' && (
          <Form.Group className="mt-1">
            <Form.Check name="checkbox" label="Remember me" />
          </Form.Group>
        )} */}
      </div>

      {step === 1 ? (
        <Button className="btn-success my-2 d-block btn-round" disabled={loading} type="submit">
          {loading ? <VscLoading className="spin" /> : <FormattedMessage id="send_otp" />}
        </Button>
      ) : (
        <div>
          <Button className="btn-success my-2 d-block btn-round" disabled={loading} type="submit">
            {loading ? (
              <VscLoading className="spin" />
            ) : from === 'forgot' ? (
              <FormattedMessage id="registration.verifyAndProceed" />
            ) : (
              <FormattedMessage id="login" />
            )}
          </Button>
          <ResendOTP username={username} counter={counter} handleOTPReset={handleOTPReset} />
        </div>
      )}
    </Form>
  );
}

export default SigninWithOTP;
